import { CompositionDetails } from "../composition-types";
import { compositionIds } from "../composition-ids";
import { RhythmPortion } from "../../rhythms/rhythm-types";

const portions: RhythmPortion[] = [
    {
        beatsPerCycle: 10,
        beatsPerMinute: 89,
        startTime: 131.5,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 92,
        startTime: 219,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 89,
        startTime: 232,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 92,
        startTime: 259,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 90,
        startTime: 272,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 96,
        startTime: 311.75,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 92,
        startTime: 374,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 94,
        startTime: 426.5,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 94,
        startTime: 509,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 102,
        startTime: 534.4,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 104,
        startTime: 581.25,
    },
    {
        beatsPerCycle: 10,
        beatsPerMinute: 0,
        startTime: 610,
    },
];

export const mereLaalanSimrit: CompositionDetails = {
    id: compositionIds.mereLaalanSimrit,
    rhythmSpec: {
        rhythmPortions: portions,
    },
    media: {
        youtubeVideoId: "VlL6Rf2aaPE",
    },
    displayName: "Mere Laalan Ki Soba - Simrit Kaur Ji",
    taals: ["jhaptaal"],
};
